<template>
    <button
        :class="button.class"
        @click="clicked"
        type="button"
        v-text="button.text"
    ></button>
</template>

<script>
export default {
    name: 'FaqsContactButton',

    props: {
        faqs: {
            required: true,
            type: Array,
        },
    },

    computed: {
        button() {
            if (this.faqs.length) {
                return {
                    class: 'btn-warning',
                    text: "Cant Find Your Answer? - Send A Message",
                }
            }

            return {
                class: 'btn-primary',
                text: 'Contact Us',
            }
        },
    },

    methods: {
        clicked() {
            this.$emit('clicked');
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Faqs/Utilities/Buttons/Contact.vue